<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="6">
                <v-card>
                    <v-form ref="daybatchForm" v-model="isValid">
                        <v-card-text>
                            <h3>Create a Day Batch containing the following Claims.</h3>
                            <i>To be applicable a Claim needs to have a Claim batch file already generated and not yet be associated with a Day Batch.</i>
                            <v-container class="pb-0" fluid>
                                <v-row class="pb-0">
                                    <v-col :key="claim.id" v-for="claim in applicableClaims" cols="12">
                                       <v-card><v-card-title>Claim #{{claim.id}}</v-card-title></v-card>
                                    </v-col>
                                </v-row>
                                <v-row
                                    align="end"
                                    class="pt-0"
                                    justify="space-between"
                                    no-gutters
                                ><v-spacer></v-spacer>
                                    <v-btn
                                        :disabled="(isLoading && !isSaving) || applicableClaims.length == 0"
                                        :loading="isSaving"
                                        @click="saveEntity"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                        >Create Day Batch</v-btn
                                    >
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                    <v-snackbar
                        :color="notifyColor"
                        :timeout="15000"
                        top
                        v-model="notifyShow"
                    >
                        {{ notifyMessage }}
                        <template v-slot:action="{ attrs }">
                            <v-btn
                                @click="notifyShow = false"
                                class="text-none"
                                icon
                                v-bind="attrs"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" no-gutters>
                <v-col cols="12">
                </v-col>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
//import DayBatch from "../../models/DayBatch.model";
import Claim from "../../models/Claim.model"; 
export default {
    props: {},
    created: async function () {
        this.applicableClaims = await this.$store.dispatch("claims/getPreSubmissionClaims");
        //load applicable claims
    },
    components: {
        //
    },
    data() {
        return {
            applicableClaims: [],
            isValid: null,
            isLoading: null,
            isSaving: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
        };
    },
    computed: {
        //
    },
    methods: {
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedDayBatch) {
            //var newDiscipline = this.disciplines.find(
            //   (x) => x.id == savedDayBatch.discipline
            //);
            //if (newDiscipline) savedDayBatch.disciplineName = newDiscipline.name;
            this.$emit("saved", savedDayBatch);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.daybatchForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var newDayBatchClaims = this.applicableClaims.map(x => new Claim().set({id: x.id}));
                this.$store
                    .dispatch(
                        "dayBatches/create",
                        {claims:  newDayBatchClaims}
                    )
                    .then(
                        () => {
                            this.notify("DayBatch successfully saved.", "success");
                            this.emitSavedEntity();
                            this.closeForm();
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
    },
};
</script>

<style lang="stylus" scoped></style>